/**
 * Currency Store (Zustand)
 *
 * Manages selected currency with persistence
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Currency } from '@/types';

const SUPPORTED_CURRENCIES: Currency[] = ['CAD', 'USD', 'AUD', 'EUR', 'GBP', 'AED'];

interface CurrencyStore {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
  getSupportedCurrencies: () => Currency[];
}

export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set) => ({
      currency: 'CAD', // Default currency

      setCurrency: (currency) => {
        if (SUPPORTED_CURRENCIES.includes(currency)) {
          set({ currency });
        }
      },

      getSupportedCurrencies: () => SUPPORTED_CURRENCIES,
    }),
    {
      name: 'arkodd-currency',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
